(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function eur(n) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }

  /* ===== Carrito AJAX + aviso ===== */
  var toastTimer;
  function toast(html) {
    var t = document.getElementById('MspToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'MspToast';
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    requestAnimationFrame(function () { t.classList.add('visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('visible'); }, 5000);
  }
  function updateCount(n) {
    document.querySelectorAll('.js-cart-count').forEach(function (b) {
      b.textContent = n;
      b.hidden = n < 1;
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.dataset.nativo) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"][name="add"]');
    var prev = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (item) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCount(cart.item_count);
          toast('<span class="msp-toast__ok">✓</span><span><strong>Añadido al carrito</strong><br>' + esc(item.product_title) + '</span><a href="/cart" class="btn msp-toast__btn">Ver carrito</a>');
          if (btn) { btn.disabled = false; btn.textContent = prev; }
        });
      })
      .catch(function () {
        form.dataset.nativo = '1';
        if (btn) { btn.disabled = false; btn.textContent = prev; }
        form.submit();
      });
  });

  /* ===== Búsqueda predictiva ===== */
  document.querySelectorAll('.js-buscador').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    var box = form.querySelector('.buscador__sugerencias');
    if (!input || !box) return;
    var timer;
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (((d || {}).resources || {}).results || {}).products || [];
            if (!prods.length) { box.hidden = true; return; }
            box.innerHTML = prods.map(function (p) {
              var src = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              if (src) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=80';
              var img = src ? '<img src="' + esc(src) + '" width="40" height="40" loading="lazy" alt="">' : '';
              var precio = p.price ? '<b>' + eur(parseFloat(p.price)) + '</b>' : '';
              return '<a href="' + esc(p.url) + '">' + img + '<span>' + esc(p.title) + '</span>' + precio + '</a>';
            }).join('') + '<a class="buscador__todos" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a>';
            box.hidden = false;
          })
          .catch(function () { box.hidden = true; });
      }, 250);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ===== Ordenar colección ===== */
  var ord = document.getElementById('OrdenarPor');
  if (ord) ord.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', ord.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ===== Vistos recientemente ===== */
  try {
    var KEY = 'msp_vistos';
    var dataEl = document.getElementById('MspProductoActual');
    var cont = document.getElementById('MspVistos');
    var lista = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (dataEl) {
      var p = JSON.parse(dataEl.textContent);
      if (p && p.u) {
        var otros = lista.filter(function (x) { return x && x.u !== p.u; });
        localStorage.setItem(KEY, JSON.stringify([p].concat(otros).slice(0, 8)));
        var pintar = otros.slice(0, 4);
        if (cont && pintar.length) {
          cont.querySelector('.grid-productos').innerHTML = pintar.map(function (x) {
            return '<article class="tarjeta" style="flex:none"><div class="tarjeta__media"><a href="' + esc(x.u) + '">' +
              (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" width="250" height="250" loading="lazy">' : '') +
              '</a></div><div class="tarjeta__body"><h3 class="tarjeta__nombre"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></h3><div class="precios"><span class="precio">' + esc((x.p || '').replace(/<[^>]*>/g, '')) + '</span></div></div></article>';
          }).join('');
          cont.hidden = false;
        }
      }
    }
  } catch (e) { /* localStorage no disponible */ }

  /* ===== Indicador de carrusel (barra que se mueve al deslizar) ===== */
  document.querySelectorAll('.carrusel').forEach(function (car) {
    function montar() {
      if (car.dataset.barra) return;
      if (car.scrollWidth <= car.clientWidth + 4) return;
      car.dataset.barra = '1';
      var barra = document.createElement('div');
      barra.className = 'carrusel-barra';
      var thumb = document.createElement('span');
      barra.appendChild(thumb);
      car.insertAdjacentElement('afterend', barra);
      function upd() {
        var wpct = Math.max(14, (car.clientWidth / car.scrollWidth) * 100);
        var max = car.scrollWidth - car.clientWidth;
        var p = max > 0 ? car.scrollLeft / max : 0;
        thumb.style.width = wpct + '%';
        thumb.style.marginLeft = (p * (100 - wpct)) + '%';
      }
      car.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    montar();
    setTimeout(montar, 600);
  });

  /* ===== Matrícula 3D: boom al entrar + inclinación con el ratón/dedo ===== */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var caras = document.querySelectorAll('.js-mat3d');
    if (caras.length && !reduce && 'IntersectionObserver' in window) {
      var obsMat = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('entra'); obsMat.unobserve(en.target); }
        });
      }, { threshold: 0.3 });
      caras.forEach(function (el) { obsMat.observe(el); });
    }
    if (reduce) return;
    document.querySelectorAll('.matriculas__img').forEach(function (cont) {
      var tilt = cont.querySelector('.mat3d__tilt');
      if (!tilt || cont.classList.contains('mat3d--spin')) return;
      var raf;
      function mover(x, y) {
        var r = cont.getBoundingClientRect();
        var px = (x - r.left) / r.width - 0.5;
        var py = (y - r.top) / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          tilt.style.transform = 'rotateY(' + (px * 30) + 'deg) rotateX(' + (-py * 22) + 'deg)';
        });
      }
      cont.addEventListener('mousemove', function (e) { mover(e.clientX, e.clientY); });
      cont.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) mover(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      cont.addEventListener('mouseleave', function () { tilt.style.transform = ''; });
      cont.addEventListener('touchend', function () { tilt.style.transform = ''; });
    });
  })();

  /* ===== Reveal al hacer scroll ===== */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var sel = '.section .h-fila, .tarjeta, .cat, .oferta-card, .marcas__item, .ventaja, .testimonio, .pieza';
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = [].slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('.carrusel') && el.getBoundingClientRect().top > vh * 0.85;
    });
    if (!els.length) return;
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('vis'); ro.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = ((i % 6) * 50) + 'ms';
      ro.observe(el);
    });
  })();

  /* ===== Cabecera inteligente (compacta + ocultar al bajar) ===== */
  (function () {
    var head = document.querySelector('.cabecera');
    if (!head) return;
    var ultimo = window.pageYOffset || 0, tick = false;
    function upd() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > 40) head.classList.add('cabecera--compacta'); else head.classList.remove('cabecera--compacta');
      if (y > 240 && y > ultimo + 6) head.classList.add('cabecera--oculta');
      else if (y < ultimo - 6 || y <= 240) head.classList.remove('cabecera--oculta');
      ultimo = y; tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; window.requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  })();

  /* ===== Barra de progreso + volver arriba ===== */
  (function () {
    var barra = document.createElement('div'); barra.className = 'msp-progreso';
    var span = document.createElement('span'); barra.appendChild(span);
    document.body.appendChild(barra);
    var btn = document.createElement('button');
    btn.className = 'msp-arriba'; btn.type = 'button';
    btn.setAttribute('aria-label', 'Volver arriba');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    var tick = false;
    function upd() {
      var doc = document.documentElement;
      var alto = doc.scrollHeight - doc.clientHeight;
      var y = window.pageYOffset || doc.scrollTop || 0;
      span.style.width = (alto > 0 ? (y / alto) * 100 : 0) + '%';
      if (y > 600) btn.classList.add('vis'); else btn.classList.remove('vis');
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; window.requestAnimationFrame(upd); }
    }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  })();

  /* ===== Vista rápida (modal) ===== */
  (function () {
    var modal;
    function cerrar() { if (modal) { modal.classList.remove('vis'); document.body.style.overflow = ''; } }
    function crear() {
      modal = document.createElement('div');
      modal.className = 'msp-modal';
      modal.innerHTML = '<div class="msp-modal__fondo"></div><div class="msp-modal__caja"><button class="msp-modal__cerrar" type="button" aria-label="Cerrar">×</button><div class="msp-modal__cont"></div></div>';
      document.body.appendChild(modal);
      modal.querySelector('.msp-modal__fondo').addEventListener('click', cerrar);
      modal.querySelector('.msp-modal__cerrar').addEventListener('click', cerrar);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
    }
    function pintar(p) {
      var cont = modal.querySelector('.msp-modal__cont');
      var raw = p.featured_image || (p.images && p.images[0]) || '';
      if (raw.indexOf('//') === 0) raw = 'https:' + raw;
      var imgSrc = raw ? raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'width=700' : '';
      var precio = eur((p.price || 0) / 100);
      var antes = (p.compare_at_price && p.compare_at_price > p.price) ? '<span class="precio--antes">' + eur(p.compare_at_price / 100) + '</span>' : '';
      var desc = (p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      if (desc.length > 320) desc = desc.slice(0, 320) + '…';
      var variantes = p.variants || [];
      var dispo = variantes.some(function (v) { return v.available; });
      var acc;
      if (variantes.length <= 1) {
        var vid = variantes[0] ? variantes[0].id : '';
        acc = '<form action="/cart/add" method="post" class="msp-modal__acc">' +
          '<input type="hidden" name="id" value="' + vid + '">' +
          '<button type="submit" name="add" class="btn" style="width:100%"' + (dispo ? '' : ' disabled') + '>' + (dispo ? 'Añadir al carrito' : 'Agotado') + '</button>' +
          '<a href="' + esc(p.url) + '" class="btn btn--oscuro" style="width:100%">Ver ficha completa</a></form>';
      } else {
        acc = '<div class="msp-modal__acc"><a href="' + esc(p.url) + '" class="btn" style="width:100%">Ver opciones</a></div>';
      }
      cont.innerHTML =
        '<div class="msp-modal__media">' + (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
        '<div class="msp-modal__info">' +
        '<h3 class="msp-modal__titulo">' + esc(p.title) + '</h3>' +
        '<div class="msp-modal__precio"><span class="precio">' + precio + '</span>' + antes + '</div>' +
        (desc ? '<div class="msp-modal__desc">' + esc(desc) + '</div>' : '') +
        acc + '</div>';
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.js-quickview') : null;
      if (!t) return;
      e.preventDefault();
      if (!modal) crear();
      modal.querySelector('.msp-modal__cont').innerHTML = '<div class="msp-modal__cargando">Cargando…</div>';
      modal.classList.add('vis'); document.body.style.overflow = 'hidden';
      var handle = t.getAttribute('data-handle');
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('qv'); return r.json(); })
        .then(function (p) { pintar(p); })
        .catch(function () { location.href = t.getAttribute('data-url') || ('/products/' + handle); });
    });
  })();

  /* ===== Cuenta atrás diaria (ofertas) ===== */
  (function () {
    var cont = document.querySelector('.js-cuenta');
    if (!cont) return;
    var bH = cont.querySelector('[data-h]'), bM = cont.querySelector('[data-m]'), bS = cont.querySelector('[data-s]');
    if (!bH || !bM || !bS) return;
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ahora = new Date();
      var fin = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 23, 59, 59);
      var d = Math.max(0, Math.floor((fin - ahora) / 1000));
      bH.textContent = dos(Math.floor(d / 3600));
      bM.textContent = dos(Math.floor((d % 3600) / 60));
      bS.textContent = dos(d % 60);
    }
    tick();
    setInterval(tick, 1000);
  })();
})();
